import { render, staticRenderFns } from "./VehicleGeneral.vue?vue&type=template&id=23550da4&scoped=true&"
import script from "./VehicleGeneral.vue?vue&type=script&lang=js&"
export * from "./VehicleGeneral.vue?vue&type=script&lang=js&"
import style0 from "./VehicleGeneral.vue?vue&type=style&index=0&id=23550da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23550da4",
  null
  
)

export default component.exports